import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIncrease: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconIncrease"><Path d="M20.4141 19L16.207 23.207L14.793 21.793L16.5859 20H8V18H16.5859L14.793 16.207L16.207 14.793L20.4141 19Z" fill="currentColor"/><Path d="M9.20703 7.79297L7.79297 9.20703L6 7.41406V16H4V7.41406L2.20703 9.20703L0.792969 7.79297L5 3.58594L9.20703 7.79297Z" fill="currentColor"/><Path d="M20 14H18V10H20V14Z" fill="currentColor"/><Path d="M20 8H18V6H16V4H20V8Z" fill="currentColor"/><Path d="M14 6H10V4H14V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIncrease;
